import React, { useEffect, useState } from "react";
import "../styles/Tasty.css";

const importAll = (r) =>
  r
    .keys()
    .map((fileName) => ({
      src: r(fileName),
      name: fileName.replace('./', ''),
    }))
    .sort((a, b) => {
      const numA = parseInt(a.name.match(/\d+/));
      const numB = parseInt(b.name.match(/\d+/));
      return numA - numB;
    });

const images = importAll(require.context('../img/tasty-webp/', false, /\.(jpg|jpeg|png|webp)$/));

const Tasty = () => {
  const [clickedImage, setClickedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [orientationMap, setOrientationMap] = useState({});

  useEffect(() => {
    const thumbnails = document.querySelectorAll(".styled-thumbnail");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add("appear");
            }, Math.random() * 500);
          }
        });
      },
      { threshold: 0.3 }
    );

    const handleImageLoad = () => {
      thumbnails.forEach((img) => observer.observe(img));
    };

    thumbnails.forEach((img) => {
      img.addEventListener('load', handleImageLoad);
    });

    return () => {
      thumbnails.forEach((img) => {
        observer.unobserve(img);
        img.removeEventListener('load', handleImageLoad);
      });
    };
  }, []);
  const handleImageLoad = (image, index) => {
    const img = new Image();
    img.src = image.src;
    img.onload = () => {
      const isVertical = img.width <= img.height;
      setOrientationMap((prevMap) => ({
        ...prevMap,
        [index]: isVertical ? "vertical" : "horizontal",
      }));
    };
  };
  // Agregar soporte para flechas del teclado
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!clickedImage) return;
      if (e.key === "ArrowRight") {
        handleNextClick();
      } else if (e.key === "ArrowLeft") {
        handlePrevClick();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [clickedImage, currentIndex]);

  const handleImageClick = (src, index) => {
    setClickedImage(src);
    setCurrentIndex(index);
  };

  const handleNextClick = (e) => {
    if (e) e.stopPropagation(); // Prevenir el cierre al hacer clic con el mouse
    const nextIndex = (currentIndex + 1) % images.length;
    setClickedImage(images[nextIndex].src);
    setCurrentIndex(nextIndex);
  };

  const handlePrevClick = (e) => {
    if (e) e.stopPropagation(); // Prevenir el cierre al hacer clic con el mouse
    const prevIndex = (currentIndex - 1 + images.length) % images.length;
    setClickedImage(images[prevIndex].src);
    setCurrentIndex(prevIndex);
  };

  const handleCloseClick = () => {
    setClickedImage(null);
  };

  const isVertical = (image) => {
    const img = new Image();
    img.src = image.src;
    return img.width <= img.height;
  };

  return (
<div className="styled-portraits-container">
  {images.map((image, index) => (
    <div key={index} className="styled-image-wrapper">
      <img
        src={image.src}
        alt={`Tasty ${index + 1}`}
        className="styled-thumbnail"
        onClick={() => handleImageClick(image.src, index)}
        onLoad={() => handleImageLoad(image, index)}
      />
    </div>
  ))}

      {clickedImage && (
        <div className="styled-overlay" onClick={handleCloseClick}>
          <img
            src={clickedImage}
            alt="Enlarged"
            className="styled-enlarged-image"
          />
          {/* Botones de navegación */}
          <button className="nav-button prev-button" onClick={handlePrevClick}>
            &#10094;
          </button>
          <button className="nav-button next-button" onClick={handleNextClick}>
            &#10095;
          </button>
        </div>
      )}
    </div>
  );
};

export default Tasty;
